import store from '@/store/index';
import { UserState } from '@/store/types';
import { IRelaysChangedEvent, RelaysChangedEvent } from '../../apis/DeviceApi';
import IEventApi from './IEventApi';
import Logger from '@/common/logging/Logger';

export default class EventApi implements IEventApi {
    private logger = Logger('event-api');
    private eventSubscribers: {[eventName: string]: Array<((arg: any) => void)>} = {};
    private subscribeToDevices: {[deviceNumber: string]: boolean} = {};

    private socket: WebSocket;
    private isConnected: boolean = false;
    private uri: string;
    private isStarted: boolean = false;
    private pingTimer: number;

    /**
     *
     */
    constructor(uri: string) {
        this.uri = uri;
        // (window as any).test = function(incomming: {type: string, event: any}) {
        //     const subscribers = this.eventSubscribers[incomming.type];
        //     if (subscribers) {
        //         for (const subscriber of subscribers) {
        //             subscriber(incomming.event);
        //         }
        //     }
        // }.bind(this);
    }

    public start(): void {
        this.isStarted = true;
        this.build();
        // console.log('state', store.state);
    }

    public stop(): void {
        this.isStarted = false;
        if (this.socket) {
          this.socket.close();
        }
        this.subscribeToDevices = {};
    }

    // subscribe<IRelaysChangedEvent>(RelaysChangedEvent, event => { ... })
    public onEvent<T>(eventName: string, callback: (event: T) => any): void {
        let subscribers = this.eventSubscribers[eventName];
        if (!subscribers) {
            this.eventSubscribers[eventName] = subscribers = new Array();
        }
        subscribers.push(callback);
    }
    public unsubscribeOnEvent<T>(eventName: string, callback: (event: T) => any): void {
        let subscribers = this.eventSubscribers[eventName];
        if (!subscribers) {
            this.eventSubscribers[eventName] = subscribers = new Array();
        }
        for (let i = 0; i < subscribers.length; i++) {
            if (subscribers[i] === callback) {
                subscribers.splice(i, 1);
                break;
            }
        }
    }

    public subscribe(deviceNumber: string): void {
        if (!this.isStarted) {
            this.start();
        }
        if (!this.subscribeToDevices[deviceNumber]) {
            this.subscribeToDevices[deviceNumber] = true;
            this.sendSubscribeToMessage();
        }
    }

    private onOpen() {
      this.isConnected = true;
      this.sendSubscribeToMessage();
      this.pingTimer = setInterval(() => {
        this.ping();
      }, 5000); // Ping ever 5 sec
    }

    private onMessage(message: MessageEvent) {
      const incomming = JSON.parse(message.data) as {type: string, event: any};
      const subscribers = this.eventSubscribers[incomming.type];
      this.logger.debug(message.data);
      if (subscribers) {
          for (const subscriber of subscribers) {
              subscriber(incomming.event);
          }
      }

      // console.log(`onMessage`, message);
    }
    private onError(err: Event) {
        this.isConnected = false;
    }

    private onClose(e: CloseEvent) {
      this.isConnected = false;
      clearInterval(this.pingTimer);
      if (this.isStarted) {
          setTimeout(this.build.bind(this), 1000);
      }
    }

    private sendSubscribeToMessage() {
        if (this.isConnected) {
            const msg: {subscribeToDevices: string[]} = {
                subscribeToDevices: [],
            };
            for (const deviceNumber of Object.keys(this.subscribeToDevices)) {
                msg.subscribeToDevices.push(deviceNumber);
            }
            this.socket.send(JSON.stringify(msg));
        }
    }

    private ping() {
        // console.log('Sending ping');
        this.socket.send('ping');
    }

    private build(): void {
        const userState = (store.state as any).user as UserState;
        const uri = this.uri.replace('{token}', userState.jwtToken || '');
        // console.log(`Connecting to ${uri}`);
        this.socket = new WebSocket(uri);
        this.socket.onopen = this.onOpen.bind(this);
        this.socket.onmessage = this.onMessage.bind(this);
        this.socket.onclose = this.onClose.bind(this);
        this.socket.onerror = this.onError.bind(this);
    }
}


